import { render, staticRenderFns } from "./invoicepdflayout-component.vue?vue&type=template&id=139ccc4b"
import script from "./invoicepdflayout-component.vue?vue&type=script&lang=ts"
export * from "./invoicepdflayout-component.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports